<template>
  <div class="base-card" :class="$attrs.class" :style="$attrs.style">
    <div v-if="$slots.header" class="base-card-header">
      <slot name="header" />
    </div>
    <div class="base-card-body">
      <slot />
    </div>
    <div v-if="$slots.footer" class="base-card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCard'
}
</script>

<style lang="scss" scoped>
.base-card {
  background: var(--bg-card, #fff);
  border-radius: var(--radius-lg, 10px);
  box-shadow: var(--shadow-card, 0 2px 12px rgba(0,0,0,0.06));
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &-header {
    padding: 12px 16px;
    border-bottom: 1px solid var(--border-color-light, #f0f2f5);
    background: linear-gradient(135deg, rgba(129,140,248,0.04) 0%, rgba(167,139,250,0.02) 100%);
  }

  &-body {
    padding: 12px 16px;
  }

  &-footer {
    padding: 10px 16px;
    border-top: 1px solid var(--border-color-light, #f0f2f5);
    background: transparent;
  }
}
</style>
